import script from "./DeactiveActionsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeactiveActionsTable.vue?vue&type=script&setup=true&lang=ts"

import "./DeactiveActionsTable.vue?vue&type=style&index=0&id=183821e8&lang=scss"

const __exports__ = script;

export default __exports__